import { AbstractControl, ValidatorFn } from '@angular/forms';

const MIN_LENGTH = 12;
const MAX_LENGTH = 255;
const SPECIAL_CHARACTER_REGEX = /[!@#$%^&*()_+\-=[\]{}|;:,.<>?]/;

const passwordTooShort: ValidatorFn = (control: AbstractControl) => {
    const value = <string>(control.value ?? '');
    if (!value) {
        return null;
    }
    return value.length < MIN_LENGTH ? { passwordTooShort: { requiredLength: MIN_LENGTH } } : null;
};

const passwordTooLong: ValidatorFn = (control: AbstractControl) => {
    const value = <string>(control.value ?? '');
    return value.length > MAX_LENGTH ? { passwordTooLong: { requiredLength: MAX_LENGTH } } : null;
};

const passwordMustIncludeUpperCharacter: ValidatorFn = (control: AbstractControl) => {
    const value = <string>(control.value ?? '');
    if (!value) {
        return null;
    }
    return /[A-Z]/.test(value) ? null : { passwordMustIncludeUpperCharacter: true };
};

const passwordMustIncludeDigit: ValidatorFn = (control: AbstractControl) => {
    const value = <string>(control.value ?? '');
    if (!value) {
        return null;
    }
    return /\d/.test(value) ? null : { passwordMustIncludeDigit: true };
};

const passwordMustIncludeSpecialCharacter: ValidatorFn = (control: AbstractControl) => {
    const value = <string>(control.value ?? '');
    if (!value) {
        return null;
    }
    return SPECIAL_CHARACTER_REGEX.test(value) ? null : { passwordMustIncludeSpecialCharacter: true };
};

const passwordHasLeadingOrTrailingWhitespace: ValidatorFn = (control: AbstractControl) => {
    const value = <string>(control.value ?? '');
    if (!value) {
        return null;
    }
    return value !== value.trim() ? { passwordHasLeadingOrTrailingWhitespace: true } : null;
};

export const passwordPolicyValidators: ValidatorFn[] = [
    passwordTooShort,
    passwordTooLong,
    passwordMustIncludeUpperCharacter,
    passwordMustIncludeDigit,
    passwordMustIncludeSpecialCharacter,
    passwordHasLeadingOrTrailingWhitespace,
];
